import '../lib/owl.carousel2';

export default class Carousel30 {

    constructor() {
        const self = this;

        $('.carousel30').each(function() {
            const $carouselContainer = $(this);
            const $carouselSlides = $carouselContainer.find('.carousel30-slides');

            $carouselSlides.owlCarousel({
                loop: false,
                dots: false,
                nav: true,
                navText: [
                    '<button class="button-as-link" aria-label="Previous slide"><img src="/assets/img/left-arrow-blue.svg" alt="" /></button>',
                    '<button class="button-as-link" aria-label="Next slide"><img src="/assets/img/right-arrow-blue.svg" alt="" /></button>'
                ],
                responsive: {
                    0: { items: 1 },
                    1024: { items: 2 },
                    1440: { items: 3 }
                }
            });

            $carouselSlides.on(
                'initialized.owl.carousel resized.owl.carousel translated.owl.carousel changed.owl.carousel',
                function(event) {
                    const owl = $(this).data('owl.carousel');
                    if (!owl) 
                        return;

                    if (!owl.settings.loop && event.item) {
                        const totalItems = owl._items.length;
                        const isFirst = event.item.index === 0;
                        const isLast = event.item.index + owl.settings.items >= totalItems;
                        const $prev = $(this).find('.owl-prev');
                        const $next = $(this).find('.owl-next');
                        $prev.toggleClass('disabled', isFirst).find('button').attr('tabindex', isFirst ? '-1' : '0');
                        $next.toggleClass('disabled', isLast).find('button').attr('tabindex', isLast ? '-1' : '0');
                    }

                    self.updateSlideFocus();
                }
            );

            self.moveButton($carouselContainer);
        });

        $(window).on('resize', () => this.updateSlideFocus());

        setTimeout(() => this.updateSlideFocus(), 500);
    }

    moveButton($carouselContainer) {
        const button = $carouselContainer.find('.carousel30-bottombuttonwrapper a');
        const $owlPrev = $carouselContainer.find('.carousel30-slides .owl-prev');

        if (button.length && $owlPrev.length) {
            button.insertAfter($owlPrev);
        }
    }

    updateSlideFocus() {
        $('.carousel30-slides').each(function() {
            const $carousel = $(this);
            const $outer = $carousel.find('.owl-stage-outer');

            if ($outer.length === 0) 
                return;

            const outerRect = $outer[0].getBoundingClientRect();

            $carousel.find('.owl-item').each(function() {
                const $item = $(this);
                const rect = this.getBoundingClientRect();
                const isVisible = rect.right > outerRect.left + 1 &&
                                  rect.left < outerRect.right - 1 &&
                                  !$item.hasClass('cloned');

                $item.attr('aria-hidden', !isVisible);
                $item.find('a, button, input, [tabindex]').attr('tabindex', isVisible ? '0' : '-1');
            });
        });
    }
}
